var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',[_vm._v(_vm._s(_vm.insurance.title))]),_vm._v(" "),_vm._l((_vm.insurance.exist),function(cardInsurance,x){return _c('td',{key:x},[_c('i',{class:cardInsurance ? 'fas fa-check-circle check-mark' : 'fas fa-times-circle cross-mark'})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }